<template>
  <el-container class="back">

  <div class="edit-area">
  <div class="row-start" style="padding: 15px 0px; width: 100%">
    <el-button class="prompt-op"  @click="publishPrompt">
      <el-icon style="font-size:16px"><Check /></el-icon>
      <span style="margin-left:5px">发布</span>
    </el-button>
    <el-button class="prompt-op" @click="deletePrompt">
      <el-icon style="font-size:16px"><Delete /></el-icon>
      <span style="margin-left:5px">下线</span>
    </el-button>
    <el-button class="prompt-op" @click="genPrompt">
      <el-icon style="font-size:16px"><CaretRight /></el-icon>
      <span style="margin-left:5px">辅助生成</span>
    </el-button>

    <el-button v-if="sendLabel === '1'" class="prompt-op" @click="stopGen">
      <img src="/pause.svg" style="width: 15px; height: 15px">
      <span style="margin-left:5px; border: 0px solid #6467f0; color:#6467f0">停止生成</span>
    </el-button>


    <el-button class="prompt-op" @click="evalPrompt">
      <el-icon style="font-size:16px"><ChatDotRound /></el-icon>
      <span style="margin-left:5px">评估讨论</span>
    </el-button>
    <el-button class="prompt-op" @click="modifyPrompt">
      <el-icon style="font-size:16px"><EditPen /></el-icon>
      <span style="margin-left:5px">修改</span>
    </el-button>
  </div>
  <div style="height:770px; border: none; overflow:auto; width: 100%;">
    <textarea v-model="response" style="width:100%; background-color:black; color:yellowgreen;padding:5px; border:none; height:100%"/>
  </div>
  </div>
  </el-container>
</template>
<script setup>
import {ref, onMounted} from 'vue';
import {fetchEventSource} from "@microsoft/fetch-event-source";
import axios from "axios";
import router from "@/router";
import {ElMessage} from 'element-plus';

const edit_mode = ref("preview");
const response = ref("");
const sendLabel = ref("0");
const prompt = ref({});
const prompt_id = ref("");
let ctrl = new AbortController();

const genPrompt = async () => {
  try {
    response.value = '';
    let mess = [];
    let conf = '';
    conf += "prompt名称:" + prompt.value.prompt_name + ";"
    conf += "归属项目:" + prompt.value.project_name + ";"
    conf += "功能描述:" + prompt.value.prompt_desc + ";"
    conf += "prompt类型:" + prompt.value.prompt_type + ";"
    mess.push({"role": "user", "content": conf})
    console.log(conf);
    console.log("==============");
    await fetchEventSource('/chat2users', {
      method: "POST",
      body: JSON.stringify({
        messages: mess,
        prompt_id: '5da473e5-cb68-4172-8330-8251c9eccecd',
        trigger: "#开始输出prompt#\n"
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        console.log(resp)
      },
      onmessage: (message) => {
        if (message.event === ''){
          response.value += "  \r";
        }else{
          response.value += message.data;
          console.log(message.data);
        }
        sendLabel.value = '1';
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
        sendLabel.value = "0";
      },
      onclose: ()=> {
        console.log('Connection closed');
        sendLabel.value = "0";
      },
      onfinish:() => {
        console.log('Finished receiving events');
        sendLabel.value = '0';
      }
    });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}

const modifyPrompt = () =>{
  if (edit_mode.value === 'preview'){
    edit_mode.value = 'eidt';
  }else{
    edit_mode.value = 'preview';
  }
}


const publishPrompt = async() =>{
  prompt.value.prompt_content = response.value;
  const resp = await axios.post('/db', {
          op: "submit", // 查询参数
          record: JSON.stringify(prompt.value), // 可以添加多个参数
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  ElMessage({
    message: '已提交更新prompt',
    type: 'success',
  })

}

const stopGen = () =>{
  if (ctrl && !ctrl.signal.aborted){
    ctrl.abort();
    ctrl = new AbortController();
  }
  sendLabel.value = "1";
}

onMounted(async()=>{
  console.log(router.currentRoute.value.query.prompt_id);
  prompt_id.value = router.currentRoute.value.query.prompt_id;
  const resp = await axios.post('/db', {
          op: "query_single", // 查询参数
          prompt_id: prompt_id.value
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  prompt.value = resp.data.response;
  if(prompt.value.prompt_content != null){
    response.value = prompt.value.prompt_content;
  }
})

</script>
<style scoped>
:root{
  --v-md-editor-padding: 0px
}

.row-start{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}


.edit-area{
  margin-left:10%;
  width: 80%;
  display: flex;
  background-color: white;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90vh;
  margin-top: 20px;
  border-radius: 12px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
}



.v-md-editor{
  padding: var(--v-md-editor-padding);
  border:none;
  height: 100%;
  background-color: #FFFFFF;
  font-size:16px;
  color: black;
  overflow-y: auto;
  border-radius: 0px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
  margin-top:0px;

}

.prompt-op{
  border: none;
  margin-left:15px;
}

.prompt-op:hover{
  background-color: whitesmoke;
  color: black;
}


</style>
